export class UserDetails {
  links: Array<any>;

  constructor(_id: number) {
    this.links = [{ link: "/users/" + _id, label: "Details", page: "details" }];
  }
}
